import api from './axios';

// FlowStep API service for interacting with the new FlowStep system
const flowStepsApi = {
  // Get all flow steps for a project
  getFlowData: async (projectId) => {
    const response = await api.get(`/flowsteps/project/${projectId}`);
    return response.data;
  },

  // Create a new flow step
  createStep: async (projectId, stepData) => {
    const response = await api.post(`/flowsteps/project/${projectId}`, stepData);
    return response.data;
  },

  // Update an existing flow step
  updateStep: async (stepId, stepData) => {
    const response = await api.put(`/flowsteps/${stepId}`, stepData);
    return response.data;
  },

  // Delete a flow step
  deleteStep: async (stepId) => {
    const response = await api.delete(`/flowsteps/${stepId}`);
    return response.data;
  },

  // Update flow connections for a project
  updateConnections: async (projectId, connections) => {
    const response = await api.put(`/flowsteps/project/${projectId}/connections`, {
      connections
    });
    return response.data;
  },

  // Bulk update flow data (steps + connections) - for VisualFlowEditor compatibility
  updateFlowData: async (projectId, flowData) => {
    const response = await api.put(`/flowsteps/project/${projectId}/flow`, flowData);
    return response.data;
  }
};

export default flowStepsApi; 